<template>
  <div id="Slideshows" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button
        v-for="(banner, i) in banners"
        :key="i"
        type="button"
        data-bs-target="#Slideshows"
        :data-bs-slide-to="i"
        :class="{ active: i === 0 }"
        :aria-current="{ true: i === 0 }"
        :aria-label="`Slide ${i}`"
      ></button>
    </div>
    <div class="carousel-inner">
      <div
        v-for="(banner, i) in banners"
        :key="i"
        :class="[{ active: i === 0 }, 'carousel-item']"
      >
        <img :src="banner" class="style-slide-img d-block w-100" alt="" />
      </div>
    </div>
    <button
      class="carousel-control-prev"
      type="button"
      data-bs-target="#Slideshows"
      data-bs-slide="prev"
    >
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button
      class="carousel-control-next"
      type="button"
      data-bs-target="#Slideshows"
      data-bs-slide="next"
    >
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Slide",
  props: {
    banners: {},
  },
};
</script>

<style scoped>
.style-slide-img {
  height: 225px;
  width: 100%;
  object-fit: cover;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  color: blue;
}
</style>
